import { render, staticRenderFns } from "./EditGST.vue?vue&type=template&id=33bfb524&"
import script from "./EditGST.vue?vue&type=script&lang=js&"
export * from "./EditGST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports